import {
  CustomSeriesPricePlotValues,
  ICustomSeriesPaneView,
  PaneRendererCustomData,
  WhitespaceData,
  Time,
  ISeriesPrimitive,
  SeriesType,
  ISeriesApi,
  IChartApi,
  SeriesAttachedParameter,
} from "lightweight-charts";
import { EarningsseriesOptions, defaultOptions } from "./options";
import { EarningsseriesData } from "./data";
import { EarningsseriesRenderer } from "./renderer";

export class EarningsseriesTiles implements ISeriesPrimitive {
  public _chart: IChartApi | undefined;
  public _series: ISeriesApi<"Custom"> | undefined;
  public _earningsSeries: Earningsseries;
  public _container: HTMLElement | undefined;

  constructor(earningsSeries: Earningsseries) {
    this._earningsSeries = earningsSeries;
  }

  attached(param: SeriesAttachedParameter<Time, SeriesType>): void {
    this._chart = param.chart as IChartApi;
    this._series = param.series as ISeriesApi<"Custom">;
    this._container = this._chart.chartElement();
  }
}

export class Earningsseries<
  TData extends EarningsseriesData = EarningsseriesData,
> implements ICustomSeriesPaneView<Time, TData, EarningsseriesOptions> {
  _renderer: EarningsseriesRenderer;
  renderedMarkers: { x: number; y: number; data: EarningsseriesData }[] = [];

  constructor() {
    this._renderer = new EarningsseriesRenderer(this);
  }

  priceValueBuilder(plotRow: EarningsseriesData): CustomSeriesPricePlotValues {
    const midPoint = (plotRow.low + plotRow.high) / 2;
    //* The values returned here are used for the autoscaling behaviour on the chart,
    //* and the last value is also used as the price value for the crosshair and price label.
    return [plotRow.low, plotRow.high, midPoint];
  }

  isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
    //* Method for checking if a specific datapoint should be considered whitespace
    //* Use this to filter out the data points which should be whitespace on the chart (and
    //* not get provided to the renderer).
    return (
      (data as Partial<TData>).low === undefined ||
      (data as Partial<TData>).high === undefined
    );
  }

  renderer(): EarningsseriesRenderer {
    return this._renderer;
  }

  update(
    data: PaneRendererCustomData<Time, TData>,
    options: EarningsseriesOptions,
  ): void {
    this._renderer.update(
      data as PaneRendererCustomData<Time, EarningsseriesData>,
      options,
    );
  }

  defaultOptions() {
    return defaultOptions;
  }
}
